// import 'videojs-youtube';

(function () {
  var iframe = document.querySelector('#modalIframe');
  var dataTitle = document.querySelector('#dataTitle');
  var dataDesignation = document.querySelector('#dataDesignation');
  var dataDesc = document.querySelector('#dataDesc');
  var dataImage = document.querySelector('#dataImage');
  var dataLinkedin = document.querySelector('#dataLinkedin');

  const vcContainer = document.querySelectorAll('.video-modal-container');
  const dismissModal = document.querySelector('[data-dismiss-modal]');
  vcContainer.forEach((vc) => {
    if (vc.querySelector('[data-video-button]')) {
      vc.querySelector('[data-video-button]').addEventListener(
        'click',
        function () {
          let videoCover = document.querySelector('.video-cover');
          let videoContainer = document.querySelector('.video-container');
          if (videoCover) {
            videoCover.classList.remove('hidden');
          }
          if (videoContainer) {
            videoContainer.classList.remove('on');
          }
          if (iframe) {
            iframe.src = this.dataset.url;
          }
          if (dataTitle) {
            dataTitle.innerHTML = this.dataset.name;
          }
          if (dataDesignation) {
            dataDesignation.innerHTML = this.dataset.designation;
          }
          if (dataDesc) {
            dataDesc.innerHTML = this.dataset.description;
          }

          if (dataImage) {
            dataImage.src = this.dataset.img;
          }
          if (dataLinkedin) {
            if (this.dataset.linkedinurl !== '') {
              dataLinkedin.classList.add('inline-block');
              dataLinkedin.classList.remove('hidden');
              dataLinkedin.href = this.dataset.linkedinurl;
            } else {
              dataLinkedin.classList.add('hidden');
              dataLinkedin.classList.remove('inline-block');
            }
          }
        }
      );
    }
  });
  if (dismissModal) {
    dismissModal.onclick = (e) => {
      if (iframe) {
        iframe.src = '';
      }
    };
  }
})();
